// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2uKsg","header":"ReportDetails_header__1L89x","title":"ReportDetails_title__16yNR","left":"ReportDetails_left__DCyfU"};